<template lang="pug">
#app
  header-component
  router-view
  //- router-view
  //- form-component
  footer-component
</template>

<script>
import { mapActions } from "vuex";
import HeaderComponent from "./packs/components/header.vue";
import FooterComponent from "./packs/components/footer.vue";

export default {
  components: {
    HeaderComponent,
    FooterComponent,
    // FormComponent
  },
  mounted() {
    this.fetchTaxonomies();
  },
  methods: {
    ...mapActions(["fetchTaxonomies"]),
  },
};
</script>

<style lang="scss" scoped>
</style>
